// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"571":"b637e9a5","708":"aa923549"}[chunkId] || chunkId) + "." + {"67":"740c551fec44ff20","68":"efac5b994c354fcb","394":"301bc8d2bf6abd53","571":"fa63ab296b82de3b","708":"b940448c8d65f20b"}[chunkId] + ".js";
};